import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { triggerPreviewFileModal } from '../../../helpers/triggerPreviewFileModal';
import useAddToBag from '../../../hooks/useAddToBag';
import {
  isProjectModalOpenSelector,
  projectModalEventLocationSelector,
} from '../../../redux/selectors/projectsSelector';
import {
  materialsInQueueSelector,
  productWithFilePreviewInQueueSelector,
} from '../../../redux/selectors/searchSelector';
import {
  setIsProjectModalOpen,
  setProjectModalEventLocation,
} from '../../../redux/sliceCreators/projectsSlice';
import {
  setMaterialsInQueue,
  setProductWithFilePreviewInQueue,
} from '../../../redux/sliceCreators/searchSlice';
import { goToLogin } from '../../../utils/helpers';
import { getUserAttributes } from '../../../utils/localstorage';

// TODO: consider removing this component and using the callbacks directly in the components that need them
const ProjectModalListener = () => {
  const isModalOpen = useSelector(isProjectModalOpenSelector);
  const projectModalEventLocation = useSelector(
    projectModalEventLocationSelector,
  );
  const materialsInQueue = useSelector(materialsInQueueSelector);
  const productWithFilePreviewInQueue = useSelector(
    productWithFilePreviewInQueueSelector,
  );
  const dispatch = useDispatch();
  const { addToBag } = useAddToBag();
  const userData = getUserAttributes();

  useEffect(() => {
    window.addEventListener('res-create-project', handleSaveProject);
    window.addEventListener('close-mb-modal', handleCloseModal);

    return () => {
      window.removeEventListener('res-create-project', handleSaveProject);
      window.removeEventListener('close-mb-modal', handleCloseModal);
    };
  }, [materialsInQueue, isModalOpen]);

  useEffect(() => {
    if (isModalOpen) {
      if (userData?.signin_token == null) {
        goToLogin();
        return;
      }
      window.dispatchEvent(
        new CustomEvent('open-create-project-modal', {
          detail: { eventLocation: projectModalEventLocation },
        }),
      );
    }
  }, [isModalOpen]);

  const handleSaveProject = async (e: CustomEvent) => {
    const { detail } = e;
    if (detail?.project_id != null) {
      dispatch(setIsProjectModalOpen(false));

      if (materialsInQueue?.length > 0) {
        // No validation needed here - the project has just been created and is valid
        await addToBag({
          materials: materialsInQueue,
          projectId: detail?.project_id,
        });
        dispatch(setMaterialsInQueue([]));
      } else {
        window.dispatchEvent(new CustomEvent('onProjectCreated'));
      }

      if (productWithFilePreviewInQueue != undefined) {
        await triggerPreviewFileModal({
          product: productWithFilePreviewInQueue,
        });
        dispatch(setProductWithFilePreviewInQueue(undefined));
      }
    }
  };

  const handleCloseModal = () => {
    dispatch(setIsProjectModalOpen(false));
    dispatch(setProjectModalEventLocation(''));
    dispatch(setProductWithFilePreviewInQueue(undefined));
  };

  return null;
};

export default ProjectModalListener;
